/* eslint-disable import/no-unresolved */
import { Modal, Box, Typography, Slide, Backdrop } from '@mui/material';
import PasscodeForm from '@/components/Forms/PasscodeForm';

const boxStyle = {
  position: 'absolute',
  height: 'fit-content',
  width: 'fit-content',
  backgroundColor: '#fff',
  borderRadius: '15px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 4,
};

interface PasscodeProps {
  show: boolean;
  handleAction: () => void;
  handleModalClose: () => void;
}
const Passcode: React.FC<PasscodeProps> = ({
  show,
  handleAction,
  handleModalClose,
}) => (
  <div>
    <Modal
      open={show}
      onClose={handleModalClose}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Slide direction="up" in={show} mountOnEnter unmountOnExit>
        <Box sx={boxStyle}>
          <Typography
            sx={{ fontSize: '20px', fontWeight: 400, color: '#051252' }}
          >
            Input Passcode to continue
          </Typography>
          <Typography sx={{ fontWeight: 400, color: '#C53B20' }}>
            Note: this action is irrevisble
          </Typography>
          <PasscodeForm handleFormAction={handleAction} />
        </Box>
      </Slide>
    </Modal>
  </div>
);

export default Passcode;
